import { NOTIFICATION_COUNT, USER_LOGINED ,USER_PURCHASE_STATUS , OWNER_DATA, EMPLOYEER_ID } from "../types";

const initialState = {
  personData: {},
  loginStatus: false,
  NotificationData : {},
  employerId: null,
};

export default function manageUserProfileReducer(state = initialState, action) {
  switch (action.type) {
    

    case USER_LOGINED:
      return {
        ...state,
        loginStatus: action.payload,
      };

     
      case NOTIFICATION_COUNT:
        return {
          ...state,
          NotificationData: action.payload,
        };

        case USER_PURCHASE_STATUS:
        return {
          ...state,
          purchaseStatus: action.payload,
        };
      
        case OWNER_DATA:
        return {
          ...state,
          ownerData: action.payload,
        };

        case EMPLOYEER_ID:
        return {
          ...state,
          ownerData: action.payload,
        };


    default:
      return state;
  }
}

